import { OrderViewModel } from '@ail/orders-api'
import { useEffect, useState } from 'react'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import CsvModal from '../../common/Modals/CsvModal/CsvModal'
import { CsvTableSection } from '../../common/Modals/CsvModal/Table/CsvTable'
import { WorkItemsCsvStructure } from './CsvStructure'
import './ViewCsv.scss'
import { WorkItemsContext } from '../WorkItemsComponent'

const ViewCsv = () => {
  const { requestId } = useParams()
  const context = useOutletContext<WorkItemsContext>()
  const navigate =  useNavigate()

  const [workItem, setWorkItem] = useState<OrderViewModel>()
  const [sections, setSections] = useState<CsvTableSection[]>()


  useEffect(() => {
    if (context.workItems) {
      setWorkItem(context.workItems.find(w => w.id === requestId))
    }
  }, [context.workItems, requestId])

  useEffect(() => {
    setSections(WorkItemsCsvStructure(workItem))
  }, [workItem])

  return (
    <CsvModal 
      sections={sections ?? []} 
      columnCount={4} 
      loading={!workItem} 
      onClose={() => navigate('/WorkItems')} 
      title={'Work item detail'} 
      onPrint={() => undefined} 
      visible 
    />
  )
}

export default ViewCsv